import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useDataRoomsActions } from "store";
import { useModals } from "hooks";

export const DataRoomFile: React.FC = (): JSX.Element => {
  const { pathname } = useLocation();
  const { errorModal } = useModals();

  const [fileLoading, setFileLoading] = useState<boolean>(true);
  const { getDownloadedDataroomsFiles, getTypeDataroomsFiles } = useDataRoomsActions();
  useEffect(() => {
    if (op == "download") {
      sendSelectedItems();
    } else if (op == "K1-textract") {
      getFilesByType("k1-files");
    } else if (op == "management-fees-textract") {
      getFilesByType("management-fees-files");
    } else if (op == "ask-ai") {
      getFilesByType("ask-ai-files");
    } else if (op == "file-data") {
      getFilesByType("file-data-files");
    } else if (op == "classification") {
      getFilesByType("classification-files");
    } else {
      setFileLoading(false);
      errorModal({ msg: "op not found" });
    }
  }, []);

  const getFilesByType = (type: string) => {
    // const selectedFileNames = selectedItems.map((item) => item.name);
    setFileLoading(true);
    getTypeDataroomsFiles(requestUuid, type)
      .then(() => {
        setFileLoading(false);
        closed();
      })
      .catch(() => {
        setFileLoading(false);
        closed();
        errorModal({ msg: "Can't get the files" });
      });
  };
  const sendSelectedItems = () => {
    // const selectedFileNames = selectedItems.map((item) => item.name);
    setFileLoading(true);
    getDownloadedDataroomsFiles(requestUuid)
      .then(() => {
        setFileLoading(false);
        closed();
      })
      .catch(() => {
        setFileLoading(false);
        // closed();
        errorModal({ msg: "Can't get the files" });
      });
  };
  function closed() {
    setTimeout("window.close()", 10);
  }
  const requestUuid: string = pathname.split("files")[1].substring(1).split("/")[0];
  const op: string = pathname.split("files")[1].substring(1).split("/")[1];
  if (fileLoading)
    return (
      <div className="measures-table-loading">
        <CircularProgress size={100} />
      </div>
    );
  return (
    <div>
      Please wait during fetching the file{" "}
      <div
        onClick={() => {
          closed();
        }}
      >
        click here to close
      </div>
    </div>
  );
};
